import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { upsertCalculationPayment } from 'modules/accommodations/features/reservations/api';

export const useCalculationPaymentMutation = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  const { mutate, isLoading } = useMutation(upsertCalculationPayment, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS_PAYMENTS, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE, {
        refetchInactive: true,
      });
      successToast(t('Your payment is successfully saved'));
    },
    onError: () => errorToast(),
  });

  return {
    isLoading,
    mutate,
  };
};
